import "./theme/init-theme";
import React, { lazy, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { ThemeProvider } from "./context/theme-context";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Loader from "./components/loading-page";

const AboutPage = lazy(() => import("./pages/about"));
const HomePage = lazy(() => import("./pages/home"));
const ProjectPage = lazy(() => import("./pages/project"));

const EXIT_MS = 550;
const MIN_LOADER_MS = 900;

const preloadPages = () =>
  Promise.all([
    import("./pages/home"),
    import("./pages/about"),
    import("./pages/project"),
  ]);

const Main = () => {
  const [showLoader, setShowLoader] = useState(true);
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    let exitTimer: ReturnType<typeof setTimeout>;

    const ready = Promise.all([
      preloadPages(),
      new Promise<void>((resolve) => setTimeout(resolve, MIN_LOADER_MS)),
    ]);

    ready.then(() => {
      setExiting(true);
      exitTimer = setTimeout(() => setShowLoader(false), EXIT_MS);
    });

    return () => {
      clearTimeout(exitTimer);
    };
  }, []);

  return (
    <>
      {showLoader && <Loader exiting={exiting} />}
      {!showLoader && (
        <Routes>
          <Route path="/*" element={<App />}>
            <Route path="home" element={<HomePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="project" element={<ProjectPage />} />
            <Route path="experience" element={<Navigate to="/about#experience" replace />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Route>
        </Routes>
      )}
    </>
  );
};

const root = createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <BrowserRouter>
    <ThemeProvider>
      <Main />
    </ThemeProvider>
  </BrowserRouter>
);
